import { Alert, Box, Paper, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { useNavigation } from "@/providers";
import { PageBreadcrumbs, PageLayout } from "@/shared/components";
import { CreateDatasetForm } from "@/shared/components/CreateDatasetForm";

export function CreateDataset() {
  const theme = useTheme();
  const { goto } = useNavigation();

  return (
    <PageLayout
      title={"Roboto - Create Dataset"}
      headerContentLeft={
        <PageBreadcrumbs>
          <Link to="/datasets">Datasets</Link>
          <span>Create Dataset</span>
        </PageBreadcrumbs>
      }
    >
      <Box>
        <Box
          sx={{
            mb: theme.spacing(2),
          }}
        >
          <Alert severity="info">
            Complete the form below to create a new dataset.
          </Alert>
        </Box>
        <Box
          component={Paper}
          variant="outlined"
          sx={{ p: theme.spacing(1.5), background: "none" }}
        >
          <Box
            sx={{
              maxWidth: "60ch",
            }}
          >
            <CreateDatasetForm
              onSuccess={(dataset) => {
                goto.dataset({ datasetId: dataset.dataset_id });
              }}
            />
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}
